import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { DynamicForm } from '../../../interfaces/dynamic-form';
import { FormParams } from '../../../interfaces/form-params';

@Component({
  selector: 'bm-boolean-form',
  templateUrl: './boolean-form.component.html',
  styleUrls: ['./boolean-form.component.scss']
})
export class BooleanFormComponent implements DynamicForm , OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() params: FormParams;

  options = [{
    name: 'All',
    value: 'all'
  }, {
    name: 'Yes',
    value: true
  }, {
    name: 'No',
    value: false,
  }];

  constructor() {
  }

  @HostBinding('className')
  get class() {
    return 'col-md-3';
  }

  ngOnInit() {

    if (this.params.value === null) {
      this.params.compactValue = 'all';
      this.params.value = null;
    } else {
      this.params.compactValue = this.params.value;
    }
  }

  onChange(option) {
    if (typeof option.value === 'boolean') {
      this.params.value = option.value;
    } else {
      this.params.value = null;
    }
  }

}
